/**
 * ProjectItemsApiClient -- HTTP client for /api/v1/Projects/by-key/{key}/items.
 *
 * Endpoint creado por la mision PROJECT-ITEMS-HUB-001 / T2.
 * Retorna items vinculados al proyecto agrupados por type, con el canon
 * (relation='canon') en seccion separada.
 *
 * Forma de la respuesta (data):
 *   {
 *     projectKey:  "nexo-desktop",
 *     displayName: "Nexo Desktop",
 *     canon:       { itemRef, itemType, relation, metadata, createdAt, updatedAt } | null,
 *     byType:      { instruction: [...], view: [...], component: [...], workflow: [...], ... },
 *     all:         [ ...todos los items, incluyendo canon... ],
 *     totalCount:  12
 *   }
 *
 * @module infrastructure/api/ProjectItemsApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Projects';

export const ProjectItemsApiClient = {
  /**
   * Obtiene los items vinculados a un proyecto por su project_key.
   * @param {string} key  - p.ej. 'nexo-desktop', 'panel-v2', 'nexo-agent'
   */
  async getByKey(key) {
    return ApiBase.get(`${BASE}/by-key/${encodeURIComponent(key)}/items`);
  },

  /**
   * SALV-T8 (nexo-api 374): TODOS los nodos de todos los proyectos, cada uno con projectKey y la lectura con respaldo
   * (filePath, route, status, note, version, verificadoPor, verificadoAt, owner). Pide sesion.
   */
  async getAll() {
    return ApiBase.get(`${BASE}/items`);
  },
};
